import { render, staticRenderFns } from "./phase-assignment-infractions.vue?vue&type=template&id=53ed9690&scoped=true&"
import script from "./phase-assignment-infractions.vue?vue&type=script&lang=ts&"
export * from "./phase-assignment-infractions.vue?vue&type=script&lang=ts&"
import style0 from "./phase-assignment-infractions.vue?vue&type=style&index=0&id=53ed9690&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ed9690",
  null
  
)

export default component.exports